<template>
  <div
    class="square-30 flex-center cursor-pointer rounded-8 bg-white shadow shrink-0"
    @click="onBack"
  >
    <van-icon name="arrow-left" />
  </div>
</template>

<script>
export default {
  name: 'GlobalBack',
  methods: {
    onBack () {
      this.$back()
    },
  },
}
</script>

<style scoped lang="scss">
</style>
